import React, { useState, useEffect, useRef } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "assets/svgIcons/AccordionExpandMoreIcon";
import CustomizedCheckbox from "commonComponents/FormElement/Checkbox";
import ChatIcon from "assets/svgIcons/ChatDoubleIcon";
import AudioIcon from "assets/svgIcons/AudioIcon";
import VolumeDownIcon from "assets/svgIcons/VolumeDownIcon";
import MailIcon from "assets/svgIcons/MailIcon";
import CloudIcon from "assets/svgIcons/CloudIcon";
import BlindShotIcon from "assets/svgIcons/BlindShotIcon";
import UserIcon from "assets/svgIcons/UserIconCircle";
import HideIcon from "assets/svgIcons/BenIcon";
import PrintIcon from "assets/svgIcons/PrintIcon";
import PlayIcon from "assets/svgIcons/AutoPlayIcon";
import HeatMapIcon from "assets/svgIcons/HeatMapIcon";
import { validateEmail } from "_helperFunctions/validateEmail";
import {
    getFeatureSetOption,
    getFeaturesList,
    isUserAdmin,
    isUserBasic,
    isUserReadOnly,
    controlType,
    memberCarTrackingLevel,
    isUserSupport,
    isUserMaster
} from "../../../constant";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import TimeIcon from "assets/svgIcons/TimeIcon";
import { AccordionStyled } from "assets/css/globle";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import {
    Container,
    Heading,
    WorkSection,
    CheckBoxWrapper,
    TextAreaBox,
    ActionWrapper,
    TimeOut,
    StartEndDate,
    DateWrapper,
    UnlockModeWrapper,
    UnlockMode,
    LiabilityWaiver,
    WaiverUploadBtnWrapper
} from "pages/Fleet/Settings/SettingsStyled";
import SelectStyled from "commonComponents/FormElement/Select";
import { Loader } from "commonComponents/Loader/Loader";
import { useHookstate } from "@hookstate/core";
import { CenteredLoader } from "commonComponents/FormElement/Checkbox/CheckboxStyled";
import {
    MAP_GLOBAL_STATES,
    FLEET_GLOBAL_STATES,
    MAX_HOLES_GLOBAL_STATE,
    SITEID_GLOBAL_STATE,
    CHECKBOX_LOADER,
    MAX_VOLUME_ALLOWED,
    ADS_GLOBAL_STATE,
    SIDENAV_GLOBAL_STATE,
} from "globalStore/globalStore";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";

// modal
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { PopUpContainer } from "assets/css/globle";
import { WeatherCheckbox } from "commonComponents/FormElement/Checkbox/WeatherCheckbox";
import moment from "moment";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import { waiverCss } from "./waiver";

export const Settings = () => {
    const navigate = useNavigate();
    const { alertMsg, redirectState, nextTabIndex, nextStageName } = useHookstate(ADS_GLOBAL_STATE);
    const { siteId, hideSubNav } = useHookstate(SITEID_GLOBAL_STATE);
    const { subNavDataState, sideDrawerActiveTabState } = useHookstate(SIDENAV_GLOBAL_STATE);

    const { t } = useTranslation();

    const {
        LoadingState,
        generalTabLoader,
        scoreCardTabLoader,
        roundManagementLoader,
        FleetLockdownLoader,
        PeakCharginLoader,
        AdminandSupportLoader
    } = useHookstate(CHECKBOX_LOADER);

    const { maxHolesAllowed, detectChangeMaxHolesAllowed } = useHookstate(
        MAX_HOLES_GLOBAL_STATE
    );
    const dispatch = useDispatch();

    const {
        PrintScorecardGlobal,
        ShareScorecardGlobal,
        AutoplayFlyoversGlobal,
        ShowOverMaxHolesOnCartGlobal,
        opcEnableLockdownGlobal,
        DisableDistancesOnMaxHolesGlobal,
        Heatmap,
        callSiteSelection
    } = useHookstate(MAP_GLOBAL_STATES);

    const {
        siteSettingsData,
        getUserRole,
        getRoundTimeOutData,
        putWelcomeScreenTextMessageData,
        getScheduledFleetLockdownData,
        getSiteOffPeakCharginData,
        getCarsData,
        getWaiverTemplatesData
    } = useSelector((state) => state?.commonReducers) || [];

    const paceSettingsData = useSelector((state) => state?.commonReducers?.getRoundTimeOutData) || [];

    const {
        fleetSettingColorGlobalState,
        enableDisableLockdownState,
        enableDisablePeekChargingState,
    } = useHookstate(FLEET_GLOBAL_STATES);

    const { maxVolumeAllowed, maxVolumeOptionTriggered } = useHookstate(MAX_VOLUME_ALLOWED);

    // modal state starts
    const [modal, setModal] = React.useState(false);
    const [messageBoxValue, setMessageBoxValue] = useState("");
    const [messageBoxCount, setMessageBoxCount] = useState(0);
    const [roundTimeout, setRoundTimeout] = useState();
    const [stagingTimeout, setStagingTimeout] = useState();
    const [resetRoundTimeout, setResetRoundTimeout] = useState();
    const [resetStagingTimeout, setResetStagingTimeout] = useState();
    const [roundManagementButton, setRoundManagementButton] = useState(false);
    const [roundTimeoutSecondsButton, setRoundTimeoutSecondsButton] = useState(false);
    const [roundManagement2Button, setRoundManagement2Button] = useState(false);
    const [schedLockdownSaveButton, setSchedLockdownSaveButton] = useState(false);
    const [offPeakSaveButton, setOffPeakSaveButton] = useState(false);
    const [schedLockdownValidationMessage, setSchedLockdownValidationMessage] = useState("");
    const [offPeakValidationMessage, setOffPeakValidationMessage] = useState("");
    const [dataSetForRoundManagement, setDataSetForRoundManagement] = useState({
        WelcomeScreenText: "",
        RoundTimeout: "60",
        StagingTimeout: "15",
        MaxNumberOfHoles: null,
        ScorecardEmail: "",
        ShowOverMaxHolesOnCart: false,
        DisableDistancesOnMaxHoles: false,
        BehindPaceWarning: false
    });
    const [scheduledFleetLockdown, setScheduledFleetLockdown] = useState({
        sflEnableLockdown: false,
        sflStartTime: new Date(2000, 0, 1, 0, 0, 0),
        sflEndTime: new Date(2000, 0, 1, 0, 0, 0),
        sflUnlockMode: "normal",
    });
    const [offPeakCharging, setOffPeakCharging] = useState({
        opcEnableLockdown: false,
        opcStartTime: new Date(2000, 0, 1, 0, getSiteOffPeakCharginData?.StartMinutes, 0),
        opcEndTime: new Date(2000, 0, 1, 0, getSiteOffPeakCharginData?.EndMinutes, 0),
        allowOpportunityCharging: false,
    });
    const [tempEmail, setTempEmail] = useState("");
    const [logoImage, setLogoImage] = useState(null);
    const [logoImageDisplay, setLogoImageDisplay] = useState(null);
    const [backgroundImage, setBackgroundImage] = useState(null);
    const [backgroundImageDisplay, setBackgroundImageDisplay] = useState(null);
    const [waiverEditorHtml, setWaiverEditorHtml] = useState(null);
    const [isSaveWaiverButtonDisabled, setIsSaveWaiverButtonDisabled] = useState(true);
    const [waiverPublishedDate, setWaiverPublishedDate] = useState("");
    const [isValid, setIsValid] = useState("");

    const logoInputRef = useRef(null);
    const backgroundInputRef = useRef(null);

    const [memberTracking, setMemberTracking] = useState(null);
    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        maxWidth: "400px",
        width: "calc(100% - 40px)",
        bgcolor: "background.paper",
        borderRadius: "5px",
        overflow: "hidden",
    };

    useEffect(() => {
        setWaiverPublishedDate("");

        if (logoInputRef.current) {
            logoInputRef.current.value = '';
        }

        if (backgroundInputRef.current) {
            backgroundInputRef.current.value = '';
        }

        if (siteId.get() !== null) {
            dispatch(COMMON_SERVICES.getFaultsServices(siteId.get()));
            dispatch(COMMON_SERVICES.getCarServices(false, siteId.get()));
            dispatch(COMMON_SERVICES.getScheduledFleetLockdownServices(0, siteId.get()));
            dispatch(COMMON_SERVICES.getSiteOffPeakCharginServices(0, siteId.get()));
            dispatch(COMMON_SERVICES.getRoundTimeOutServices(siteId.get()));
            dispatch(COMMON_SERVICES.getMessagesFromCarsServices("", siteId.get()));
            dispatch(COMMON_SERVICES.getWaiverTemplateService(parseInt(siteId.get())));
        }
    }, [siteId.get()]);

    useEffect(() => {
        if (Object.keys(getWaiverTemplatesData).length > 0) {
            setLogoImageDisplay(getWaiverTemplatesData.LogoImage ? `data:image/png;base64,${getWaiverTemplatesData.LogoImage}` : null);
            setBackgroundImageDisplay(getWaiverTemplatesData.BackgroundImage ? `data:image/png;base64,${getWaiverTemplatesData.BackgroundImage}` : null);
            setWaiverEditorHtml(getWaiverTemplatesData.HtmlContent);

            setWaiverPublishedDate(getWaiverTemplatesData.PublishedDate ? 'Last Published ' + moment.utc(getWaiverTemplatesData.PublishedDate).utcOffset(-siteSettingsData?.TimeZoneOffset).format("DD-MMM-YYYY HH:mm:ss") : "Not Published Yet");
        }
    }, [getWaiverTemplatesData]);

    useEffect(() => {
        if (getRoundTimeOutData) {
            setRoundTimeout(getRoundTimeOutData?.site?.RoundTimeoutSeconds / 60);
            setStagingTimeout(getRoundTimeOutData?.site?.StagingTimeoutSeconds / 60);
            setResetRoundTimeout(getRoundTimeOutData?.site?.RoundTimeoutSeconds / 60);
            setResetStagingTimeout(
                getRoundTimeOutData?.site?.StagingTimeoutSeconds / 60
            );
        }
    }, [getRoundTimeOutData]);

    useEffect(() => {
        if (Object.keys(siteSettingsData).length > 0) {
            setMessageBoxValue(siteSettingsData?.WelcomeScreenText ? siteSettingsData?.WelcomeScreenText : "");
            setMessageBoxCount(siteSettingsData?.WelcomeScreenText?.length ? siteSettingsData?.WelcomeScreenText?.length : 0);
            setTempEmail(siteSettingsData?.EmailAddress ? siteSettingsData?.EmailAddress : "");
            PrintScorecardGlobal.set(siteSettingsData.PrintScorecard);
            ShareScorecardGlobal.set(siteSettingsData.ShareScorecardEnabled)
            AutoplayFlyoversGlobal.set(siteSettingsData.AutoFlyovers);
            Heatmap.set(siteSettingsData?.GreenViewsEnabled);

            // Round Management
            ShowOverMaxHolesOnCartGlobal.set(siteSettingsData.MaxHolesExceededAlert);
            DisableDistancesOnMaxHolesGlobal.set(
                siteSettingsData.MaxHolesExceededDistancesDisabled
            );

            setDataSetForRoundManagement({
                ...dataSetForRoundManagement,
                ShowOverMaxHolesOnCart: siteSettingsData.MaxHolesExceededAlert,
                DisableDistancesOnMaxHoles:
                    siteSettingsData.MaxHolesExceededDistancesDisabled,
                MaxNumberOfHoles: siteSettingsData.MaxHolesAllowedFleet,
                BehindPaceWarning: siteSettingsData.PaceWarningPopupEnabled,
            });
            maxHolesAllowed.set(siteSettingsData.MaxHolesAllowedFleet);

            opcEnableLockdownGlobal.set(siteSettingsData.PaceEnabled);
            setOffPeakCharging({
                ...offPeakCharging,
                opcEnableLockdown: siteSettingsData.PaceEnabled,
            });
            maxVolumeAllowed.set(siteSettingsData.MaxAmpSetting);
            maxVolumeOptionTriggered.set(false);
            setMemberTracking(siteSettingsData.MemberCarTrackingLevel)
        }
    }, [siteSettingsData, LoadingState.get() === true, siteId.get()]);

    useEffect(() => {
        if (getScheduledFleetLockdownData && Object.keys(getScheduledFleetLockdownData)?.length > 0 && siteSettingsData && Object.keys(siteSettingsData).length !== 0 && !_.isNull(siteSettingsData?.TimeZoneOffset)) {
            var startDt = moment.utc(getScheduledFleetLockdownData?.StartTimeInUtc).utcOffset(-siteSettingsData.TimeZoneOffset);
            var endDt = moment.utc(getScheduledFleetLockdownData?.EndTimeInUtc).utcOffset(-siteSettingsData.TimeZoneOffset);

            setScheduledFleetLockdown({
                ...scheduledFleetLockdown,
                enableLockdownSFL: getScheduledFleetLockdownData?.IsEnabled,
                sflStartTime: new Date(2000, 0, 1, startDt.hour(), startDt.minute(), 0),
                sflEndTime: new Date(2000, 0, 1, endDt.hour(), endDt.minute(), 0),
                sflUnlockMode:
                    getScheduledFleetLockdownData?.UnlockGuardianMode === 2
                        ? "staged"
                        : "normal",
            });
            enableDisableLockdownState.set(getScheduledFleetLockdownData?.IsEnabled);
        }
    }, [getScheduledFleetLockdownData, siteSettingsData]);

    useEffect(() => {
        if (getSiteOffPeakCharginData && Object.keys(getSiteOffPeakCharginData)?.length > 0) {
            if (getSiteOffPeakCharginData?.StartMinutes != null && getSiteOffPeakCharginData?.EndMinutes != null) {
                let starDate = new Date(2000, 0, 1, 0, 0, 0);
                starDate.setMinutes(getSiteOffPeakCharginData?.StartMinutes);
                let endDate = new Date(2000, 0, 1, 0, 0, 0);
                endDate.setMinutes(getSiteOffPeakCharginData?.EndMinutes);

                setOffPeakCharging({
                    ...offPeakCharging,
                    opcEnableLockdown: getSiteOffPeakCharginData?.IsEnabled,
                    opcStartTime: starDate,
                    opcEndTime: endDate
                });
            }

            enableDisablePeekChargingState.set(getSiteOffPeakCharginData?.IsEnabled);
        }
    }, [getSiteOffPeakCharginData]);

    useEffect(() => {
        let getWelcomeTxt = putWelcomeScreenTextMessageData && putWelcomeScreenTextMessageData?.WelcomeScreenText;
        setMessageBoxValue(getWelcomeTxt);
    }, [putWelcomeScreenTextMessageData]);

    const modules = {
        toolbar: [
            [{ header: "1" }, { header: "2" }, { font: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            ["bold", "italic", "underline", "strike"],
            ["link", "image"],
            [{ color: [] }, { background: [] }],
            ["blockquote", "code-block"],
        ],
    };

    const doesFleetHasFusionCars = () => {
        return getCarsData?.some(x => x.Car.CarControlType == controlType.Fusion);
    }

    const cancelLockdownFunc = () => {
        redirectState.set(false);
        alertMsg.set(false);
        setSchedLockdownSaveButton(false);

        var startDt = moment.utc(getScheduledFleetLockdownData?.StartTimeInUtc).utcOffset(-siteSettingsData.TimeZoneOffset);
        var endDt = moment.utc(getScheduledFleetLockdownData?.EndTimeInUtc).utcOffset(-siteSettingsData.TimeZoneOffset);

        setScheduledFleetLockdown({
            ...scheduledFleetLockdown,
            sflEnableLockdown: getScheduledFleetLockdownData?.IsEnabled,
            sflStartTime: new Date(2000, 0, 1, startDt.hour(), startDt.minute(), 0),
            sflEndTime: new Date(2000, 0, 1, endDt.hour(), endDt.minute(), 0),
            sflUnlockMode:
                getScheduledFleetLockdownData?.UnlockGuardianMode === 2
                    ? "staged"
                    : "normal",
        });
        enableDisableLockdownState.set(getScheduledFleetLockdownData?.IsEnabled);
    };

    const cancelPeakChargingFunc = () => {
        setOffPeakSaveButton(false);
        setOffPeakCharging({
            ...offPeakCharging,
            opcEnableLockdown: getSiteOffPeakCharginData?.IsEnabled,
            opcStartTime: new Date(2000, 0, 1, 0, getSiteOffPeakCharginData?.StartMinutes, 0),
            opcEndTime: new Date(2000, 0, 1, 0, getSiteOffPeakCharginData?.EndMinutes, 0),
        });
        enableDisablePeekChargingState.set(getSiteOffPeakCharginData?.IsEnabled);
    };

    const handleWelcomeScreenText = (e) => {
        setRoundManagementButton(true);
        setMessageBoxValue(e.target.value);
        setMessageBoxCount(e.target.value.length);
    };

    const handleTextRoundManagementOnSave = (name) => {
        setRoundManagementButton(false);
        setRoundManagement2Button(false);
        if (name === "screen") {
            dispatch(
                COMMON_SERVICES.putWelcomeScreenTextMessageServices(
                    messageBoxValue,
                    siteId.get()
                )
            );
            roundManagementLoader.set(true);

            setTimeout(() => {
                roundManagementLoader.set(false);
            }, 2000);
            setMessageBoxValue("");
        }

        if (name === "scorecardEmail") {
            let isValidEmail = tempEmail && tempEmail?.trim() !== "" ? validateEmail(tempEmail?.trim()) : true;
            if (isValidEmail) {
                setIsValid("");
                dispatch(
                    COMMON_SERVICES.putScoreCardEmailServices(tempEmail.trim(), siteId.get())
                );
                scoreCardTabLoader.set(true);
                setTimeout(() => {
                    scoreCardTabLoader.set(false);
                }, 2000);
            }
            else {
                setIsValid(<p style={{ color: "red" }}>{t("Email_is_not_valid")}</p>);
            }
        }

        if (name === "max_volume_allowed") {
            if (maxVolumeAllowed.get()) {
                dispatch(
                    COMMON_SERVICES.putMaxVolumeSettingService(maxVolumeAllowed.get(), siteId.get())
                );
            }
        }
    };

    //*************RESET BUTTONS*****************//
    const handleTextRoundManagementOnReset = (name) => {
        // reset button for Welcome screen text
        if (name === "screen") {
            setRoundManagementButton(false);
            setDataSetForRoundManagement({
                ...dataSetForRoundManagement,
                WelcomeScreenText:
                    siteSettingsData && siteSettingsData?.WelcomeScreenText,
            });
            setMessageBoxValue(
                siteSettingsData && siteSettingsData?.WelcomeScreenText
            );
            setMessageBoxCount(
                siteSettingsData && siteSettingsData?.WelcomeScreenText.length
            );
        }

        // reset button for scorecardEmail
        else if (name === "scorecardEmail") {
            setRoundManagement2Button(false);
            setDataSetForRoundManagement({
                ...dataSetForRoundManagement,
                ScorecardEmail: siteSettingsData && siteSettingsData?.EmailAddress,
            });
            let getEmailAddress = siteSettingsData && siteSettingsData?.EmailAddress;
            setTempEmail(getEmailAddress);
            // setTempEmail(siteSettingsData && siteSettingsData?.EmailAddress);
        } else if (name === "max_volume_allowed") {
            maxVolumeAllowed.set(siteSettingsData.MaxAmpSetting);
            maxVolumeOptionTriggered.set(false);
        } else {
        }
    };

    //*************RESET BUTTONS*****************/
    const handleSflNormalStagedBtn = (nameBtn, tableName) => {
        setSchedLockdownSaveButton(true);
        if (tableName === "SFL") {
            if (nameBtn === "normal") {
                setScheduledFleetLockdown({
                    ...scheduledFleetLockdown,
                    sflUnlockMode: "normal",
                });
            } else if (nameBtn === "staged") {
                setScheduledFleetLockdown({
                    ...scheduledFleetLockdown,
                    sflUnlockMode: "staged",
                });
            }
        }
    };

    const handleSflStartTime = (time) => {
        setSchedLockdownSaveButton(true);
        setScheduledFleetLockdown({
            ...scheduledFleetLockdown,
            sflStartTime: time,
        });
    };

    const handleSflEndTime = (time) => {
        setSchedLockdownSaveButton(true);
        setScheduledFleetLockdown({
            ...scheduledFleetLockdown,
            sflEndTime: time
        });
    };

    const handleOpcStartTime = (time) => {
        if (time > offPeakCharging.opcEndTime) {
            setOffPeakValidationMessage("Start time is after End time")
            setOffPeakSaveButton(false);
        } else {
            if (offPeakValidationMessage != "")
                setOffPeakValidationMessage("");

            setOffPeakSaveButton(true);
        }

        setOffPeakCharging({
            ...offPeakCharging,
            opcStartTime: time
        });
    };

    const handleOpcEndTime = (time) => {
        if (time < offPeakCharging.opcStartTime) {
            setOffPeakValidationMessage("End time is before Start time");
            setOffPeakSaveButton(false);
        } else {
            if (offPeakValidationMessage != "")
                setOffPeakValidationMessage("");

            setOffPeakSaveButton(true);
        }

        setOffPeakCharging({
            ...offPeakCharging,
            opcEndTime: time
        });
    };

    const handleOffPeakCharging = () => {
        if (offPeakValidationMessage != "") {
            return;
        }

        setOffPeakSaveButton(false);

        var sm = offPeakCharging.opcStartTime.getHours() * 60 + offPeakCharging.opcStartTime.getMinutes();
        var em = offPeakCharging.opcEndTime.getHours() * 60 + offPeakCharging.opcEndTime.getMinutes();

        const payload = {
            IsEnabled: enableDisablePeekChargingState.value,
            StartMinutes: sm,
            EndMinutes: em,
            AllowOpportunityCharging: offPeakCharging.allowOpportunityCharging,
        };
        PeakCharginLoader.set(true);

        dispatch(
            COMMON_SERVICES.putSiteOffPeakChargingServices(payload, siteId.get())
        ).then(() => {
            PeakCharginLoader.set(false);
        });
    };

    const handleScheduledFleetLockdown = () => {
        if (schedLockdownValidationMessage != "") {
            return;
        }

        setSchedLockdownSaveButton(false);
        // Convert the time values from the incoming site's local time to UTC
        var ms = moment.utc('2000-01-01T00:00:00');
        ms.hour(scheduledFleetLockdown.sflStartTime.getHours()).minute(scheduledFleetLockdown.sflStartTime.getMinutes());
        ms.utcOffset(siteSettingsData.TimeZoneOffset);
        // We don't care about the date component, so leave it at the default 1/1/2000
        // (Offsetting the time may have changed the date).
        ms.year(2000).month(0).date(1);

        // Do the same for the end time
        var me = moment.utc('2000-01-01T00:00:00');
        me.hour(scheduledFleetLockdown.sflEndTime.getHours()).minute(scheduledFleetLockdown.sflEndTime.getMinutes());
        me.utcOffset(siteSettingsData.TimeZoneOffset);
        me.year(2000).month(0).date(1);

        const payload = {
            IsEnabled: enableDisableLockdownState.value,
            StartTimeInUtc: ms.format('YYYY-MM-DDTHH:mm:ss.SSS'),
            EndTimeInUtc: me.format('YYYY-MM-DDTHH:mm:ss.SSS'),
            UnlockGuardianMode:
                scheduledFleetLockdown.sflUnlockMode === "normal" ? 1 : 2,
        };

        FleetLockdownLoader.set(true);
        dispatch(
            COMMON_SERVICES.putUpdateScheduleLockDownServices(payload, siteId.get())
        ).then(() => {
            dispatch(
                COMMON_SERVICES.getScheduledFleetLockdownServices(0, siteId.get())
            );
            FleetLockdownLoader.set(false);
            redirectState.set(false);
            alertMsg.set(false);
        });
    };

    const handleCheckBox = (e) => {
        const payload = {
            siteId: siteId.get(),
            code: "WA",
            value: e,
            enumValue: 0,
        };

        dispatch(
            COMMON_SERVICES.putFleetSettingsServices(payload, siteId.get())
        ).then(() => {
            fleetSettingColorGlobalState.set(e);
            setModal(false);
        });
    };

    const handleSubmitRoundTimeoutSeconds = () => {
        setRoundTimeoutSecondsButton(false);
        const site = {
            ...paceSettingsData,
            site: {
                ...paceSettingsData.site,
                StagingTimeoutSeconds: (stagingTimeout * 60).toString(),
                RoundTimeoutSeconds: (roundTimeout * 60).toString(),
            },
        };
        const payload = {
            siteId: Number(siteId.get()),
            siteSettings: siteSettingsData,
            paceSettings: site,
        };
        LoadingState.set(true);
        roundManagementLoader.set(true);
        dispatch(
            COMMON_SERVICES.putRoundTimeOutServices(payload, Number(siteId.get()))
        );
        setTimeout(() => {
            LoadingState.set(false);
            roundManagementLoader.set(false);
        }, 2000);
    };

    const handleRound = (e) => {
        setRoundTimeoutSecondsButton(true);
        setRoundTimeout(e.target.value);
    };

    const holesList = [
        {
            value: "0",
            lable: t("No_Limit"),
        },
        {
            value: "9",
            lable: "9",
        },
        {
            value: "18",
            lable: "18 ",
        },
    ];

    // Maximum Volume Allowed Options
    const maxVolumeAllowedOptions = [
        {
            value: "Mute",
            lable: t("Mute"),
        },
        {
            value: "Low",
            lable: t("Low"),
        },
        {
            value: "Medium",
            lable: t("Medium"),
        },
        {
            value: "High",
            lable: t("High"),
        },
    ];

    const handleSaveMaxHolesAllowed = () => {
        const maxHoleValue = maxHolesAllowed.value.toString();
        roundManagementLoader.set(true);
        dispatch(
            COMMON_SERVICES.putMaxHolesNumService(maxHoleValue, siteId.get())
        ).then(() => {
            detectChangeMaxHolesAllowed.set(false);
            roundManagementLoader.set(false);
        });
    };

    const handleResetMaxHolesAllowed = () => {
        detectChangeMaxHolesAllowed.set(false);
        maxHolesAllowed.set(
            siteSettingsData && siteSettingsData?.MaxHolesAllowedFleet
        );
    };

    function handleReset() {
        setRoundTimeoutSecondsButton(false);
        setRoundTimeout(resetRoundTimeout);
        setStagingTimeout(resetStagingTimeout);
    }

    const handleDiscardPopup = () => {
        redirectState.set(false);
        alertMsg.set(false);

        hideSubNav.set(true);
        if (nextStageName.get() === "siteSelection") {
            callSiteSelection.set(true);
            setSchedLockdownSaveButton(false);
            return;
        }
        navigate(`/${nextStageName.get().toLowerCase()}`);
        let activeTab = nextTabIndex.get();
        let activeName = nextStageName.get();
        sideDrawerActiveTabState.set(activeTab);
        subNavDataState.set(activeName);

        localStorage.setItem("sideDrawerActiveTabState", nextTabIndex.get());

        localStorage.setItem("subNavState", "true");
        localStorage.setItem("subNavDataState", nextStageName.get());
    };

    const handleLogoImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setLogoImage(file);

            const reader = new FileReader();
            reader.onloadend = () => {
                let base64String = reader.result.split(',')[1];
                base64String = cleanBase64String(base64String);
                setLogoImage(base64String);

                setLogoImageDisplay(reader.result);
            };
            reader.readAsDataURL(file);

            setIsSaveWaiverButtonDisabled(false);
        }
    };

    const clearLogoImage = (e) => {
        setLogoImage(null);
        setLogoImageDisplay(null);

        if (logoInputRef.current) {
            logoInputRef.current.value = '';
        }

        setIsSaveWaiverButtonDisabled(false);
    };

    const handleBackgroundImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                let base64String = reader.result.split(',')[1];
                base64String = cleanBase64String(base64String);
                setBackgroundImage(base64String);

                setBackgroundImageDisplay(reader.result);
            };
            reader.readAsDataURL(file);

            setIsSaveWaiverButtonDisabled(false);
        }
    };

    const clearBackgroundImage = (e) => {
        setBackgroundImage(null);
        setBackgroundImageDisplay(null);

        if (backgroundInputRef.current) {
            backgroundInputRef.current.value = '';
        }

        setIsSaveWaiverButtonDisabled(false);
    };

    const handleWaiverEditorHtmlChange = (value) => {

        // replace special characters
        if (value) {
            value = value.replaceAll('“', '&ldquo;'); // fancy left double quote
            value = value.replaceAll('”', '&rdquo;'); // fancy right double quote
            value = value.replaceAll('‘', '&lsquo;'); // fancy left single quote
            value = value.replaceAll('’', '&rsquo;'); // fancy right single quote
        }

        setWaiverEditorHtml(value);
    };

    const handlePublishWaiverTemplate = () => {
        var request = {
            siteId: parseInt(siteId.get())
        };

        dispatch(COMMON_SERVICES.publishWaiverTemplateService(request)).then(() => {
            dispatch(COMMON_SERVICES.getWaiverTemplateService(parseInt(siteId.get()))); // reload waiver to get published date
        });
    }

    const handleSaveWaiverTemplate = () => {
        var request = {
            logoImage: logoImage,
            backgroundImage: backgroundImage,
            waiverTemplate: waiverEditorHtml,
            siteId: parseInt(siteId.get()),
            htmlFile: generateHtmlFile()
        };

        dispatch(
            COMMON_SERVICES.saveWaiverTemplateService(request)
        );

        setIsSaveWaiverButtonDisabled(true);
    }

    const cleanBase64String = (str) => {
        return str.replace(/\s/g, '').replace(/(\r\n|\n|\r)/gm, '');
    };

    const handleCancelWaiverTemplate = () => {
        setLogoImage(null);
        setBackgroundImage(null);
        setLogoImageDisplay(null);
        setBackgroundImageDisplay(null);
        setWaiverEditorHtml(null);
        setIsSaveWaiverButtonDisabled(true);

        if (logoInputRef.current) {
            logoInputRef.current.value = '';
        }

        if (backgroundInputRef.current) {
            backgroundInputRef.current.value = '';
        }
    }

    const generateHtmlFile = () => {
        var bg = backgroundImageDisplay ? `url('${backgroundImageDisplay}')` : 'none';
        var contentTopPadding = logoImageDisplay ? '110px' : '10px';
        var logo = logoImageDisplay ? `<img class='logo' src='${logoImageDisplay}' />` : '';

        return `<html>
            <head>
              <style>
                body {
                    margin: 0;
                    padding: 0;
                    background-color: white;
                    font-family: "Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
                }

                .background {
                    padding: 0;
                    width: 1280px;
                    height: 800px;
                    margin: 0 auto;
                    background-image: ${bg};
                    background-size: cover;
                    background-repeat: no-repeat;
                    background-attachment: fixed;
                    background-position: center;
                    overflow-y: auto;
                }

                .content {
                    padding-left: 30px !important;
                    padding-right: 30px !important;
                    padding-top: ${contentTopPadding} !important;
                    padding-bottom: 120px !important;
                    white-space: normal !important;
                }

                .logo {
                    height: 100px;
                    position: absolute;
                    top: 10px;
                    left: 50%;
                    transform: translateX(-50%);
                    max-width: 100%;
                    z-index: 10
                }

                ${waiverCss}
              </style>
            </head>
            <body>
              <div class="background" >
                <div class="ql-editor content" >
                    ${logo}
                    ${waiverEditorHtml}
                </div>
              </div>
            </body>
          </html>
        `;
    }

    const handleMemberCarTrackingChange = (e) => {
        setMemberTracking(e.target.value);
        AdminandSupportLoader.set(true);
        dispatch(COMMON_SERVICES.putUpdateMemberCarTrackingLevelServices(e.target.value, siteId.get()))
            .then(() => { AdminandSupportLoader.set(false) });
    }

    return (
        <>
            <Container>
                <AccordionStyled>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Heading>
                                <h3>{t("General")}</h3>
                            </Heading>
                        </AccordionSummary>
                        <AccordionDetails>
                            <WorkSection className="fleet-general-tab">
                                <>
                                    {generalTabLoader.get() && (
                                        <CenteredLoader className="innerSectionLoader">
                                            <Loader />
                                        </CenteredLoader>
                                    )}
                                    <div>
                                        <CheckBoxWrapper>
                                            <WeatherCheckbox
                                                identification="WA"
                                                disabledState={isUserReadOnly(
                                                    getUserRole && getUserRole?.Role
                                                )}
                                            />
                                            <CloudIcon />
                                        </CheckBoxWrapper>
                                    </div>
                                    <div>
                                        <CheckBoxWrapper>
                                            <CustomizedCheckbox
                                                identification="SD"
                                                label={t("Hide_distances")}
                                                name="Hide Distances"
                                                lockdownText="hideDistance"
                                                width={15}
                                                height={15}
                                                disabled={
                                                    getFeatureSetOption(
                                                        siteSettingsData?.Features,
                                                        getFeaturesList().golfer_experience
                                                    ) || isUserReadOnly(getUserRole?.Role)
                                                }
                                            />
                                            <HideIcon className="cloud-icon" />
                                        </CheckBoxWrapper>
                                    </div>


                                    <div>
                                        <CheckBoxWrapper>
                                            <CustomizedCheckbox
                                                identification="BS"
                                                label={t("Blind_shots")}
                                                name="Blind Shot"
                                                lockdownText="blindShots"
                                                width={15}
                                                height={15}
                                                disabled={
                                                    getFeatureSetOption(
                                                        siteSettingsData?.Features,
                                                        getFeaturesList().golfer_experience
                                                    ) || isUserReadOnly(getUserRole?.Role)
                                                }
                                            />
                                            <BlindShotIcon className="cloud-icon" />
                                        </CheckBoxWrapper>
                                    </div>
                                    <div>
                                        <CheckBoxWrapper>
                                            <CustomizedCheckbox
                                                identification="AF"
                                                label={t("Auto-play_flyovers")}
                                                name="Auto-play flyovers"
                                                lockdownText="autoplay"
                                                width={15}
                                                height={15}
                                                disabled={
                                                    getFeatureSetOption(
                                                        siteSettingsData?.Features,
                                                        getFeaturesList().flyovers,
                                                    ) || isUserReadOnly(getUserRole?.Role)
                                                }
                                            />
                                            <PlayIcon className="cloud-icon" />
                                        </CheckBoxWrapper>
                                    </div>
                                    <div>
                                        <CheckBoxWrapper>
                                            <CustomizedCheckbox
                                                disabled={getFeatureSetOption(
                                                    siteSettingsData?.Features,
                                                    getFeaturesList().golfer_experience
                                                ) || isUserReadOnly(getUserRole?.Role)}
                                                identification="SH"
                                                label={t("Show_names_on_Welcome_Screen")}
                                                name="Show names on welcome screen"
                                                lockdownText="showNames"
                                                width={15}
                                                height={15}
                                            />
                                            <UserIcon className="cloud-icon" />
                                        </CheckBoxWrapper>
                                    </div>
                                    <div>
                                        <CheckBoxWrapper>
                                            <CustomizedCheckbox
                                                disabled={getFeatureSetOption(
                                                    siteSettingsData?.Features,
                                                    getFeaturesList().golfer_experience
                                                ) || isUserReadOnly(getUserRole?.Role)}
                                                identification="SP"
                                                label={t("Show_Plays_Like_Yardage")}
                                                name="Show plays like yardage"
                                                lockdownText="playsLikeYardage"
                                                width={15}
                                                height={15}
                                            />
                                            <UserIcon className="cloud-icon" />
                                        </CheckBoxWrapper>
                                    </div>
                                    <div className="select-wrapper">
                                        <p className="label text-with-icon">
                                            <VolumeDownIcon />
                                            {t("Max_volume_allowed")}
                                        </p>
                                        <SelectStyled
                                            disabled={isUserReadOnly(getUserRole?.Role)}
                                            value={maxVolumeAllowed.get()}
                                            data={maxVolumeAllowedOptions}
                                        />
                                        <ActionWrapper>
                                            <Button
                                                variant="outlined"
                                                disabled={isUserReadOnly(getUserRole?.Role)}
                                                onClick={() => handleTextRoundManagementOnSave("max_volume_allowed")}
                                                className={
                                                    maxVolumeOptionTriggered.get() ? "active" : "disabled"
                                                }
                                            >
                                                {t("Save")}
                                            </Button>
                                            <Button
                                                variant="outlined"
                                                disabled={isUserReadOnly(getUserRole?.Role)}
                                                className="send-btn"
                                                onClick={() => handleTextRoundManagementOnReset("max_volume_allowed")}
                                            >
                                                {t("Reset")}
                                            </Button>
                                        </ActionWrapper>
                                    </div>
                                    {
                                        <div>
                                            <CheckBoxWrapper>
                                                <CustomizedCheckbox
                                                    identification="GV"
                                                    label={t("Heatmap")}
                                                    name="Heatmap"
                                                    lockdownText="Heatmap"
                                                    width={15}
                                                    height={15}
                                                    disabled={isUserReadOnly(getUserRole && getUserRole?.Role) || isUserBasic(getUserRole && getUserRole?.Role)}
                                                />
                                                <HeatMapIcon className="cloud-icon" />
                                            </CheckBoxWrapper>
                                        </div>
                                    }

                                </>
                            </WorkSection>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Heading>
                                <h3>{t("Scorecard")}</h3>
                            </Heading>
                        </AccordionSummary>
                        <AccordionDetails>
                            <WorkSection>
                                {scoreCardTabLoader.get() && (
                                    <CenteredLoader className="innerSectionLoader">
                                        <Loader />
                                    </CenteredLoader>
                                )}
                                <div>
                                    <CheckBoxWrapper>
                                        <CustomizedCheckbox
                                            identification="SC"
                                            label={t("Scorecard")}
                                            name="Scorecard"
                                            lockdownText="scoreCards"
                                            width={15}
                                            height={15}
                                            disabled={isUserReadOnly(getUserRole?.Role)}
                                        />
                                        <MailIcon className="cloud-icon" />
                                    </CheckBoxWrapper>
                                </div>
                                <div>
                                    <CheckBoxWrapper>
                                        <WeatherCheckbox
                                            identification="PS"
                                            disabledState={
                                                isUserReadOnly(getUserRole?.Role)
                                            }
                                        />
                                        <PrintIcon className="cloud-icon" />
                                    </CheckBoxWrapper>
                                </div>
                                <div>
                                    <CheckBoxWrapper>
                                        <CustomizedCheckbox
                                            identification="SSC"
                                            label={t("Share_Scorecard")}
                                            name="ShareScorecard"
                                            lockdownText="shareScoreCards"
                                            width={15}
                                            height={15}
                                            disabled={!isUserAdmin(getUserRole?.Role)}
                                        />
                                        <ChatIcon className="cloud-icon" />
                                    </CheckBoxWrapper>
                                </div>
                                <div>
                                    <p className="label">{t("Scorecard_email")}</p>
                                    <input
                                        type="text"
                                        name="scorecardEmail"
                                        className="scorecard-email-input"
                                        value={tempEmail}
                                        onChange={(e) => {
                                            setRoundManagement2Button(true);
                                            setTempEmail(e.target.value);
                                        }}
                                        disabled={
                                            getFeatureSetOption(
                                                siteSettingsData && siteSettingsData?.Features,
                                                getFeaturesList().golfer_experience
                                            ) ||
                                            isUserBasic(getUserRole && getUserRole?.Role) ||
                                            isUserReadOnly(getUserRole && getUserRole?.Role)
                                        }
                                    />
                                    <p className="p-0 mb-10">
                                        <small>{isValid}</small>
                                    </p>
                                    <ActionWrapper>
                                        <Button
                                            variant="outlined"
                                            disabled={
                                                getFeatureSetOption(
                                                    siteSettingsData && siteSettingsData?.Features,
                                                    getFeaturesList().golfer_experience
                                                ) ||
                                                isUserBasic(getUserRole && getUserRole?.Role) ||
                                                isUserReadOnly(getUserRole && getUserRole?.Role)
                                            }
                                            onClick={() => handleTextRoundManagementOnSave("scorecardEmail")}
                                            className={roundManagement2Button ? "active" : "disabled"}
                                        >
                                            {t("Save")}
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            disabled={
                                                getFeatureSetOption(
                                                    siteSettingsData && siteSettingsData?.Features,
                                                    getFeaturesList().golfer_experience
                                                ) ||
                                                isUserBasic(getUserRole && getUserRole?.Role) ||
                                                isUserReadOnly(getUserRole && getUserRole?.Role)
                                            }
                                            className="send-btn"
                                            onClick={() => handleTextRoundManagementOnReset("scorecardEmail")}
                                        >
                                            {t("Reset")}
                                        </Button>
                                    </ActionWrapper>
                                </div>
                            </WorkSection>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Heading>
                                <h3>{t("Round_Management")}</h3>
                            </Heading>
                        </AccordionSummary>
                        <AccordionDetails>
                            <WorkSection>
                                {roundManagementLoader.get() && (
                                    <CenteredLoader className="innerSectionLoader">
                                        <Loader />
                                    </CenteredLoader>
                                )}
                                <div>
                                    <TextAreaBox>
                                        <p className="label">{t("Welcome_Screen_text")}</p>
                                        <textarea
                                            disabled={
                                                isUserBasic(getUserRole && getUserRole?.Role) ||
                                                isUserReadOnly(getUserRole && getUserRole?.Role)
                                            }
                                            id="screen"
                                            name="screen"
                                            rows="3"
                                            cols="50"
                                            value={messageBoxValue}
                                            onChange={(e) => handleWelcomeScreenText(e)}
                                            maxLength={60}
                                            style={{ resize: "none" }}
                                        ></textarea>
                                        <span>
                                            {messageBoxCount}/60 {t("chars_remaining")}
                                        </span>
                                    </TextAreaBox>
                                    <ActionWrapper>
                                        <Button
                                            variant="outlined"
                                            disabled={
                                                isUserBasic(getUserRole && getUserRole?.Role) ||
                                                isUserReadOnly(getUserRole && getUserRole?.Role)
                                            }
                                            onClick={() => handleTextRoundManagementOnSave("screen")}
                                            className={roundManagementButton ? "active" : "disabled"}
                                        >
                                            {t("Save")}
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            disabled={
                                                isUserBasic(getUserRole && getUserRole?.Role) ||
                                                isUserReadOnly(getUserRole && getUserRole?.Role)
                                            }
                                            className="send-btn"
                                            onClick={() => handleTextRoundManagementOnReset("screen")}
                                        >
                                            {t("Reset")}
                                        </Button>
                                    </ActionWrapper>
                                </div>
                                <div>
                                    <TimeOut>
                                        <div>
                                            <p className="label">{t("Round_timeout")} </p>
                                            <input
                                                disabled={!isUserAdmin(getUserRole && getUserRole?.Role)}
                                                type="number"
                                                min={0}
                                                max={99}
                                                value={roundTimeout}
                                                onChange={(e) => handleRound(e)}
                                            />
                                            <span>mins</span>
                                        </div>
                                    </TimeOut>
                                    <TimeOut>
                                        <div>
                                            <p className="label">{t("Staging_timeout")} </p>
                                            <input
                                                disabled={isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role)}
                                                type="number"
                                                min={0}
                                                max={99}
                                                value={stagingTimeout}
                                                onChange={(e) => {
                                                    setStagingTimeout(e.target.value);
                                                    setRoundTimeoutSecondsButton(true);
                                                }}
                                            />
                                            <span>mins</span>
                                        </div>
                                    </TimeOut>
                                    <ActionWrapper className="mb-40">
                                        <Button
                                            variant="outlined"
                                            disabled={
                                                isUserBasic(getUserRole && getUserRole?.Role) ||
                                                isUserReadOnly(getUserRole && getUserRole?.Role)
                                            }
                                            onClick={handleSubmitRoundTimeoutSeconds}
                                            className={roundTimeoutSecondsButton ? "active" : "disabled"}
                                        >
                                            {t("Save")}
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            disabled={
                                                getFeatureSetOption(
                                                    siteSettingsData && siteSettingsData?.Features,
                                                    getFeaturesList().real_time_tracking
                                                ) ||
                                                isUserBasic(getUserRole && getUserRole?.Role) ||
                                                isUserReadOnly(getUserRole && getUserRole?.Role)
                                            }
                                            onClick={handleReset}
                                            className="send-btn"
                                        >
                                            {t("Reset")}
                                        </Button>
                                    </ActionWrapper>
                                </div>
                                <div className="select-wrapper">
                                    <p className="label">{t("Max_Number_of_Holes")}</p>
                                    <SelectStyled
                                        disabled={
                                            getFeatureSetOption(
                                                siteSettingsData && siteSettingsData?.Features,
                                                getFeaturesList().golfer_experience
                                            ) ||
                                            isUserBasic(getUserRole && getUserRole?.Role) ||
                                            isUserReadOnly(getUserRole && getUserRole?.Role)
                                        }
                                        value={maxHolesAllowed.get()}
                                        data={holesList}
                                        IconComponent={ExpandMoreIcon}
                                    />

                                    <ActionWrapper className="mb-40">
                                        <Button
                                            variant="outlined"
                                            disabled={
                                                getFeatureSetOption(
                                                    siteSettingsData && siteSettingsData?.Features,
                                                    getFeaturesList().golfer_experience
                                                ) ||
                                                isUserBasic(getUserRole && getUserRole?.Role) ||
                                                isUserReadOnly(getUserRole && getUserRole?.Role) ||
                                                !detectChangeMaxHolesAllowed.get()
                                            }
                                            onClick={() => handleSaveMaxHolesAllowed()}
                                            className={
                                                getFeatureSetOption(
                                                    siteSettingsData && siteSettingsData?.Features,
                                                    getFeaturesList().golfer_experience
                                                ) ||
                                                    isUserBasic(getUserRole && getUserRole?.Role) ||
                                                    isUserReadOnly(getUserRole && getUserRole?.Role) ||
                                                    !detectChangeMaxHolesAllowed.get()
                                                    ? ""
                                                    : "active"
                                            }
                                        >
                                            {t("Save")}
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            onClick={() => handleResetMaxHolesAllowed()}
                                            className="send-btn"
                                        >
                                            {t("Reset")}
                                        </Button>
                                    </ActionWrapper>

                                    <CheckBoxWrapper className="mb-10">
                                        <CustomizedCheckbox
                                            lockdownText="showOverMaxHoles"
                                            label={t("Show_Over_Max_Holes_on_Cart")}
                                            name="Show Over Max Holes on Cart"
                                            width={15}
                                            height={15}
                                            disabled={
                                                getFeatureSetOption(
                                                    siteSettingsData && siteSettingsData?.Features,
                                                    getFeaturesList().golfer_experience
                                                ) ||
                                                isUserBasic(getUserRole && getUserRole?.Role) ||
                                                isUserReadOnly(getUserRole && getUserRole?.Role)
                                            }
                                        />
                                    </CheckBoxWrapper>
                                    <CheckBoxWrapper className="mb-10">
                                        <CustomizedCheckbox
                                            lockdownText="disableDistancesOnMaxHoles"
                                            label={t("Disable_Distances_on_Max_Holes")}
                                            name="Disable Distances on Max Holes"
                                            width={15}
                                            height={15}
                                            disabled={
                                                getFeatureSetOption(
                                                    siteSettingsData && siteSettingsData?.Features,
                                                    getFeaturesList().golfer_experience
                                                ) ||
                                                isUserBasic(getUserRole && getUserRole?.Role) ||
                                                isUserReadOnly(getUserRole && getUserRole?.Role)
                                            }
                                        />
                                    </CheckBoxWrapper>

                                </div>
                            </WorkSection>
                        </AccordionDetails>
                    </Accordion>

                    {!getFeatureSetOption(
                        siteSettingsData &&
                        siteSettingsData !== null &&
                        siteSettingsData?.Features,
                        getFeaturesList().car_control
                    ) &&
                        getUserRole &&
                        getUserRole.Role != 6 && (
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2a-content"
                                    id="panel2a-header"
                                >
                                    <Heading>
                                        <h3>{t("Alerts")}</h3>
                                    </Heading>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <WorkSection>
                                        <>
                                            <div>
                                                <CheckBoxWrapper className="no-side-border">
                                                    <p className="label text-with-icon">
                                                        <AudioIcon />
                                                        {t("Audible_alert")}
                                                    </p>

                                                    <CustomizedCheckbox
                                                        disabled={isUserReadOnly(
                                                            getUserRole && getUserRole?.Role
                                                        )}
                                                        label={t("When_new_fleet_alert_detected")}
                                                        name="Audible Alert"
                                                        lockdownText="alertBeep"
                                                        width={15}
                                                        height={15}
                                                    />
                                                </CheckBoxWrapper>
                                            </div>
                                            <div>
                                                <CheckBoxWrapper className="no-side-border">
                                                    <p className="mb-4 label text-with-icon">
                                                        <ChatIcon />
                                                        {t("Pop-up_alert")}
                                                    </p>

                                                    <CustomizedCheckbox
                                                        disabled={isUserReadOnly(
                                                            getUserRole && getUserRole?.Role
                                                        )}
                                                        label={t("When_new_fleet_alert_detected")}
                                                        name="Pop-up alert"
                                                        lockdownText="alertPopup"
                                                        width={15}
                                                        height={15}
                                                    />
                                                </CheckBoxWrapper>
                                            </div>
                                            <div></div>
                                            <div></div>
                                        </>
                                    </WorkSection>
                                </AccordionDetails>
                            </Accordion>
                        )}
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Heading>
                                <h3>{t("Scheduled_Fleet_Lockdown")}</h3>
                            </Heading>
                        </AccordionSummary>
                        <AccordionDetails>
                            <WorkSection>
                                {FleetLockdownLoader.get() && (
                                    <CenteredLoader className="innerSectionLoader">
                                        <Loader />
                                    </CenteredLoader>
                                )}
                                <div>
                                    <CheckBoxWrapper className="no-side-border mb-22">
                                        <CustomizedCheckbox
                                            disabled={
                                                getFeatureSetOption(
                                                    siteSettingsData &&
                                                    siteSettingsData !== null &&
                                                    siteSettingsData?.Features,
                                                    getFeaturesList().car_control
                                                ) ||
                                                isUserBasic(getUserRole && getUserRole?.Role) ||
                                                isUserReadOnly(getUserRole && getUserRole?.Role)
                                            }
                                            lockdownText="fleetlockdown"
                                            label={t("Enable_Lockdown")}
                                            name="Enable Lockdown SFL"
                                            width={15}
                                            height={15}
                                            activeButtonScheduled={setSchedLockdownSaveButton}
                                        />
                                    </CheckBoxWrapper>
                                    <DateWrapper>
                                        <StartEndDate>
                                            <p className="label">{t("Start")}</p>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <MobileTimePicker
                                                    disabled={
                                                        !enableDisableLockdownState.get() ||
                                                        getFeatureSetOption(
                                                            siteSettingsData &&
                                                            siteSettingsData !== null &&
                                                            siteSettingsData?.Features,
                                                            getFeaturesList().car_control
                                                        )
                                                    }
                                                    value={scheduledFleetLockdown.sflStartTime}
                                                    onChange={(newValue) => {
                                                        handleSflStartTime(newValue);
                                                    }}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                            <TimeIcon />
                                        </StartEndDate>
                                        <StartEndDate>
                                            <p className="label">{t("End")}</p>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <MobileTimePicker
                                                    disabled={
                                                        !enableDisableLockdownState.get() ||
                                                        getFeatureSetOption(
                                                            siteSettingsData &&
                                                            siteSettingsData !== null &&
                                                            siteSettingsData?.Features,
                                                            getFeaturesList().car_control
                                                        )
                                                    }
                                                    value={scheduledFleetLockdown.sflEndTime}
                                                    onChange={(newValue) => {
                                                        handleSflEndTime(newValue);
                                                    }}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                            <TimeIcon />
                                        </StartEndDate>
                                    </DateWrapper>

                                    <p className="timeValidationMessage">{schedLockdownValidationMessage}</p>

                                    <UnlockModeWrapper>
                                        <p className="label">{t("Unlock_Mode")}</p>
                                        <UnlockMode>
                                            <button
                                                style={
                                                    getFeatureSetOption(
                                                        siteSettingsData && siteSettingsData?.Features,
                                                        getFeaturesList().car_control
                                                    )
                                                        ? { backgroundColor: "#d3d3d3" }
                                                        : {}
                                                }
                                                disabled={getFeatureSetOption(
                                                    siteSettingsData &&
                                                    siteSettingsData !== null &&
                                                    siteSettingsData?.Features,
                                                    getFeaturesList().car_control
                                                )}
                                                onClick={() => handleSflNormalStagedBtn("normal", "SFL")}
                                                className={scheduledFleetLockdown.sflUnlockMode === "normal" ? "active" : "disabled"}
                                            >
                                                {t("Normal")}
                                            </button>
                                            <button
                                                style={
                                                    getFeatureSetOption(
                                                        siteSettingsData && siteSettingsData?.Features,
                                                        getFeaturesList().car_control
                                                    )
                                                        ? { backgroundColor: "#d3d3d3" }
                                                        : {}
                                                }
                                                disabled={getFeatureSetOption(
                                                    siteSettingsData &&
                                                    siteSettingsData !== null &&
                                                    siteSettingsData?.Features,
                                                    getFeaturesList().car_control
                                                )}
                                                onClick={() => handleSflNormalStagedBtn("staged", "SFL")}
                                                className={scheduledFleetLockdown.sflUnlockMode === "staged" ? "active" : "disabled"}
                                            >
                                                {t("Staged")}
                                            </button>
                                        </UnlockMode>
                                    </UnlockModeWrapper>
                                    <ActionWrapper>
                                        <Button
                                            style={
                                                getFeatureSetOption(
                                                    siteSettingsData && siteSettingsData?.Features,
                                                    getFeaturesList().car_control
                                                )
                                                    ? { backgroundColor: "#d3d3d3" }
                                                    : {}
                                            }
                                            disabled={
                                                getFeatureSetOption(
                                                    siteSettingsData && siteSettingsData?.Features,
                                                    getFeaturesList().car_control
                                                ) ||
                                                isUserBasic(getUserRole && getUserRole?.Role) ||
                                                isUserReadOnly(getUserRole && getUserRole?.Role)
                                            }
                                            onClick={handleScheduledFleetLockdown}
                                            className={schedLockdownSaveButton ? "active" : "disabled"}
                                        >
                                            {t("Save")}
                                        </Button>
                                        <Button
                                            onClick={cancelLockdownFunc}
                                            style={
                                                getFeatureSetOption(
                                                    siteSettingsData && siteSettingsData?.Features,
                                                    getFeaturesList().car_control
                                                )
                                                    ? { backgroundColor: "#d3d3d3" }
                                                    : {}
                                            }
                                            disabled={
                                                getFeatureSetOption(
                                                    siteSettingsData && siteSettingsData?.Features,
                                                    getFeaturesList().car_control
                                                ) ||
                                                isUserBasic(getUserRole && getUserRole?.Role) ||
                                                isUserReadOnly(getUserRole && getUserRole?.Role)
                                            }
                                        >
                                            {t("Cancel")}
                                        </Button>
                                    </ActionWrapper>
                                </div>
                                <div className="web-only"></div>
                                <div className="web-only"></div>
                                <div className="web-only"></div>
                            </WorkSection>
                        </AccordionDetails>
                    </Accordion>
                    {doesFleetHasFusionCars() &&
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Heading>
                                    <h3>{t("Off_Peak_Charging")}</h3>
                                    <p>{t("Li-Ion_cars_only")}</p>
                                </Heading>
                            </AccordionSummary>
                            <AccordionDetails>
                                <WorkSection>
                                    {PeakCharginLoader.get() && (
                                        <CenteredLoader className="innerSectionLoader">
                                            <Loader />
                                        </CenteredLoader>
                                    )}
                                    <div>
                                        <CheckBoxWrapper className="no-side-border mb-22">
                                            <CustomizedCheckbox
                                                lockdownText="peekcharging"
                                                label={t("Enable_Off_Peak_Charging")}
                                                name="Enable Lockdown OPC"
                                                width={15}
                                                height={15}
                                                activeButtonOff={setOffPeakSaveButton}
                                                disabled={
                                                    getFeatureSetOption(
                                                        siteSettingsData &&
                                                        siteSettingsData !== null &&
                                                        siteSettingsData?.Features,
                                                        getFeaturesList().real_time_tracking
                                                    ) ||
                                                    isUserBasic(getUserRole && getUserRole?.Role) ||
                                                    isUserReadOnly(getUserRole && getUserRole?.Role)
                                                }
                                            />
                                        </CheckBoxWrapper>
                                        <DateWrapper>
                                            <StartEndDate>
                                                <p className="label">{t("Start")}</p>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <MobileTimePicker
                                                        disabled={
                                                            !enableDisablePeekChargingState.get() ||
                                                            getFeatureSetOption(
                                                                siteSettingsData &&
                                                                siteSettingsData !== null &&
                                                                siteSettingsData?.Features,
                                                                getFeaturesList().real_time_tracking
                                                            )
                                                        }
                                                        value={offPeakCharging.opcStartTime}
                                                        onChange={(newValue) => {
                                                            handleOpcStartTime(newValue);
                                                        }}
                                                        renderInput={(params) => <TextField {...params} />}
                                                    />
                                                </LocalizationProvider>
                                                <TimeIcon />
                                            </StartEndDate>
                                            <StartEndDate>
                                                <p className="label">{t("End")}</p>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <MobileTimePicker
                                                        disabled={
                                                            !enableDisablePeekChargingState.get() ||
                                                            getFeatureSetOption(
                                                                siteSettingsData &&
                                                                siteSettingsData !== null &&
                                                                siteSettingsData?.Features,
                                                                getFeaturesList().real_time_tracking
                                                            )
                                                        }
                                                        value={offPeakCharging.opcEndTime}
                                                        onChange={(newValue) => {
                                                            handleOpcEndTime(newValue);
                                                        }}
                                                        renderInput={(params) => <TextField {...params} />}
                                                    />
                                                </LocalizationProvider>
                                                <TimeIcon />
                                            </StartEndDate>
                                        </DateWrapper>

                                        <p className="timeValidationMessage">{offPeakValidationMessage}</p>

                                        <ActionWrapper>
                                            <Button
                                                disabled={
                                                    getFeatureSetOption(
                                                        siteSettingsData &&
                                                        siteSettingsData !== null &&
                                                        siteSettingsData?.Features,
                                                        getFeaturesList().real_time_tracking
                                                    ) ||
                                                    isUserBasic(getUserRole && getUserRole?.Role) ||
                                                    isUserReadOnly(getUserRole && getUserRole?.Role)
                                                }
                                                style={
                                                    getFeatureSetOption(
                                                        siteSettingsData && siteSettingsData?.Features,
                                                        getFeaturesList().real_time_tracking
                                                    )
                                                        ? { backgroundColor: "#d3d3d3" }
                                                        : {}
                                                }
                                                onClick={handleOffPeakCharging}
                                                className={offPeakSaveButton ? "active" : "disabled"}
                                            >
                                                {t("Save")}
                                            </Button>
                                            <Button
                                                onClick={cancelPeakChargingFunc}
                                                disabled={
                                                    getFeatureSetOption(
                                                        siteSettingsData &&
                                                        siteSettingsData !== null &&
                                                        siteSettingsData?.Features,
                                                        getFeaturesList().real_time_tracking
                                                    ) ||
                                                    isUserBasic(getUserRole && getUserRole?.Role) ||
                                                    isUserReadOnly(getUserRole && getUserRole?.Role)
                                                }
                                                style={
                                                    getFeatureSetOption(
                                                        siteSettingsData && siteSettingsData?.Features,
                                                        getFeaturesList().real_time_tracking
                                                    )
                                                        ? { backgroundColor: "#d3d3d3" }
                                                        : {}
                                                }
                                            >
                                                {t("Cancel")}
                                            </Button>
                                        </ActionWrapper>
                                    </div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </WorkSection>
                            </AccordionDetails>
                        </Accordion>
                    }

                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Heading>
                                <h3>{t("Liability_Waiver")}</h3>
                            </Heading>
                        </AccordionSummary>
                        <AccordionDetails>
                            <WorkSection>
                                <LiabilityWaiver>
                                    <div className="flex-parent">
                                        <div className="child">
                                            <p className="label">Logo</p>
                                            <WaiverUploadBtnWrapper>
                                                <input type="file" className="waiver-input" ref={logoInputRef} onChange={handleLogoImageChange} disabled={!(isUserAdmin(getUserRole?.Role) || isUserSupport(getUserRole?.Role) || isUserMaster(getUserRole?.Role))} />
                                            </WaiverUploadBtnWrapper>
                                            <ActionWrapper>
                                                <Button
                                                    style={{ marginTop: "10px" }}
                                                    disabled={!logoImageDisplay || !(isUserAdmin(getUserRole?.Role) || isUserSupport(getUserRole?.Role) || isUserMaster(getUserRole?.Role))}
                                                    onClick={() => clearLogoImage()}
                                                    className={!logoImageDisplay || !(isUserAdmin(getUserRole?.Role) || isUserSupport(getUserRole?.Role) || isUserMaster(getUserRole?.Role)) ? "disabled" : "active"}
                                                >
                                                    {t("Remove_Logo")}
                                                </Button>
                                            </ActionWrapper>
                                        </div>

                                        <div className="child">
                                            <p className="label">Background Image</p>
                                            <WaiverUploadBtnWrapper>
                                                <input type="file" className="waiver-input" ref={backgroundInputRef} onChange={handleBackgroundImageChange} disabled={!(isUserAdmin(getUserRole?.Role) || isUserSupport(getUserRole?.Role) || isUserMaster(getUserRole?.Role))} />
                                            </WaiverUploadBtnWrapper>
                                            <ActionWrapper>
                                                <Button
                                                    style={{ marginTop: "10px" }}
                                                    disabled={!backgroundImageDisplay || !(isUserAdmin(getUserRole?.Role) || isUserSupport(getUserRole?.Role) || isUserMaster(getUserRole?.Role))}
                                                    onClick={() => clearBackgroundImage()}
                                                    className={!backgroundImageDisplay || !(isUserAdmin(getUserRole?.Role) || isUserSupport(getUserRole?.Role) || isUserMaster(getUserRole?.Role)) ? "disabled" : "active"}
                                                >
                                                    {t("Remove_Background")}
                                                </Button>
                                            </ActionWrapper>
                                        </div>
                                        <div className="child-two">
                                            <ReactQuill
                                                value={waiverEditorHtml}
                                                onChange={handleWaiverEditorHtmlChange}
                                                onKeyUp={() => isSaveWaiverButtonDisabled ? setIsSaveWaiverButtonDisabled(false) : () => { }}
                                                theme="snow"
                                                readOnly={!(isUserAdmin(getUserRole?.Role) || isUserSupport(getUserRole?.Role) || isUserMaster(getUserRole?.Role))}
                                                modules={modules}
                                                className="quill-editor"
                                            />
                                        </div>
                                    </div>
                                    <div className="preview">
                                        <h3>Preview:</h3>
                                        <div style={{
                                            border: "1px solid #ccc",
                                            position: "relative",
                                            padding: "0",
                                            width: "1280px",
                                            height: "800px",
                                            margin: "0 auto",
                                            backgroundImage: backgroundImageDisplay ? `url(${backgroundImageDisplay})` : 'none',
                                            backgroundSize: "cover",
                                            backgroundRepeat: "no-repeat",
                                            backgroundAttachment: "local", /* this is set to fixed in rendered file for VDU use */
                                            backgroundPosition: "center",
                                            overflowY: "hidden"
                                        }}
                                        >
                                        <div
                                            className="ql-editor"
                                            style={{
                                                paddingLeft: "30px",
                                                paddingRight: "30px",
                                                paddingTop: logoImageDisplay ? "110px" : "10px",
                                                zIndex: 1
                                            }}>

                                            {logoImageDisplay &&
                                                <img
                                                    src={logoImageDisplay}
                                                    height={100}
                                                    alt="Logo"
                                                    style={{
                                                        position: "absolute",
                                                        top: "10px",
                                                        left: "50%",
                                                        transform: "translateX(-50%)",
                                                        maxWidth: "100%",
                                                        zIndex: 10
                                                    }}
                                                />
                                            }

                                            <div
                                                dangerouslySetInnerHTML={{ __html: waiverEditorHtml }}
                                            />
                                        </div>

                                        </div>
                                    </div>

                                    <ActionWrapper>
                                        <Button
                                            disabled={isSaveWaiverButtonDisabled || !(isUserAdmin(getUserRole?.Role) || isUserSupport(getUserRole?.Role) || isUserMaster(getUserRole?.Role))}
                                            onClick={() => handleSaveWaiverTemplate()}
                                            className={isSaveWaiverButtonDisabled || !(isUserAdmin(getUserRole?.Role) || isUserSupport(getUserRole?.Role) || isUserMaster(getUserRole?.Role)) ? "disabled" : "active"}
                                        >
                                            {t("Save")}
                                        </Button>
                                        <Button onClick={handleCancelWaiverTemplate} disabled={!(isUserAdmin(getUserRole?.Role) || isUserSupport(getUserRole?.Role) || isUserMaster(getUserRole?.Role))}>
                                            {t("Cancel")}
                                        </Button>
                                        <Button
                                            disabled={!isSaveWaiverButtonDisabled && (isUserAdmin(getUserRole?.Role) || isUserSupport(getUserRole?.Role) || isUserMaster(getUserRole?.Role))}
                                            onClick={() => handlePublishWaiverTemplate()}
                                            style={{ marginLeft: "40px"}}
                                            className={!isSaveWaiverButtonDisabled && (isUserAdmin(getUserRole?.Role) || isUserSupport(getUserRole?.Role) || isUserMaster(getUserRole?.Role)) ? "disabled" : "active"}
                                        >
                                            {t("Publish")}
                                        </Button>
                                        <div>{waiverPublishedDate}</div>
                                    </ActionWrapper>
                                </LiabilityWaiver>
                            </WorkSection>
                        </AccordionDetails>
                    </Accordion>
                    {(isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role)) && <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            style={{background:"var(--admin-tab-bg)"}}
                        >
                            <Heading>
                                <h3>{t("Admin_and_Support_Settings")}</h3>
                            </Heading>
                        </AccordionSummary>
                        <AccordionDetails>
                            <WorkSection>
                                {AdminandSupportLoader.get() && (
                                    <CenteredLoader className="innerSectionLoader">
                                        <Loader />
                                    </CenteredLoader>
                                )}
                                <CheckBoxWrapper className="mt-20">
                                    <CustomizedCheckbox
                                        lockdownText="powermanagement"
                                        label={t("Power_management")}
                                        name="Power Management"
                                        width={15}
                                        height={15}
                                    />
                                </CheckBoxWrapper>
                                <CheckBoxWrapper className="mt-20">
                                    <CustomizedCheckbox
                                        lockdownText="memberantitamper"
                                        label={t("Member_Anti_Tamper")}
                                        name="Member Anti Tamper"
                                        width={15}
                                        height={15}
                                    />
                                </CheckBoxWrapper>
                                <div className="select-wrapper">
                                    <p className="label">{t("Member_Car_Tracking")}</p>
                                    <FormControl size="small">
                                        <Select
                                            value={memberTracking}
                                            name="CarSetting"
                                            onChange={(e) => {
                                                handleMemberCarTrackingChange(e)
                                            }}
                                            inputProps={{ "aria-label": "Without label" }}
                                        >
                                            <MenuItem value={memberCarTrackingLevel.Never}>{t("Never")}</MenuItem>
                                            <MenuItem value={memberCarTrackingLevel.Always}>{t("Always")}</MenuItem>
                                            <MenuItem value={memberCarTrackingLevel.InsideGeoFence}>{t("Within_Geofence")}</MenuItem>
                                            <MenuItem value={memberCarTrackingLevel.OnCourseOrPlayingGolf}>{t("OnCourse_or_PlayingGolf")}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </WorkSection>
                        </AccordionDetails>
                    </Accordion>
                    }
                </AccordionStyled>

                <Modal
                    open={modal}
                    onClose={() => setModal(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <PopUpContainer>
                            <h2>{t("Confirm")}</h2>
                            <p>{t("Engage_weather_alert?")}</p>
                            <div className="action-btn">
                                <button
                                    onClick={() => {
                                        handleCheckBox(!fleetSettingColorGlobalState.get());
                                    }}
                                    className="primary"
                                >
                                    {t("Yes")}
                                </button>
                                <button onClick={() => setModal(false)}>{t("No")}</button>
                            </div>
                        </PopUpContainer>
                    </Box>
                </Modal>
                <Modal
                    open={alertMsg.get()}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <PopUpContainer>
                            <h2>{t("Confirm")}</h2>
                            <p>{t("Discard_changes")}?</p>
                            <div className="action-btn">
                                <button className="primary" onClick={handleDiscardPopup}>
                                    {t("Yes")}
                                </button>
                                <button
                                    onClick={() => {
                                        alertMsg.set(false);
                                    }}
                                >
                                    {t("No")}
                                </button>
                            </div>
                        </PopUpContainer>
                    </Box>
                </Modal>
            </Container>
        </>
    );
};
